<template>
  <NAvatar v-bind="mergedAttrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </NAvatar>
</template>

<script lang="ts" setup>
import { merge } from 'lodash-es'
import type { AvatarProps } from 'naive-ui'
import { NAvatar } from 'naive-ui'
import { useAttrs } from 'vue'

const attrs: AvatarProps = useAttrs()

const defaultAttrs: AvatarProps = {
  round: true,
  size: 'small',
}

const mergedAttrs: AvatarProps = merge(defaultAttrs, attrs)

defineSlots()
</script>
